/* eslint-disable camelcase */
import * as db from '@shared/types/database'
import { SelectOption } from '@alpha/ink'
import * as graph from '@shared/types/graphql'
import { TemplateValue } from '@shared/types/database'

export interface ProjectPayload {
  title: string,
  description: string
}

export interface TabRoute<T> {
  name: string,
  /** Will overwrite name if provided */
  displayName?: string,
  attribute?: keyof T
  info?: string
}

export interface User {
  fullName: string
  userName: string
  id: string
  abbreviation: string
  email?: string | null | undefined
  admin: boolean
}

export interface UsersResponse {
  allUsers: User[]
  followers: User[]
}

export interface TaggedUser {
  item: string,
  replacement: string,
  id: string,
  username: string
}

export interface FixedComment extends db.MongoComment {
  correctTimestamp: number,
  commentId: string,
  edited?: boolean
}

export interface CreateCommentInput {
  userid: string,
  firstname: string,
  lastname: string,
  email: string,
  comment: string,
  tagged_user_ids: string[]
}
export interface EditCommentInput {
  comment_id: string,
  comment: string,
  userid: string,
  firstname: string,
  email: string,
  edited: boolean
}

export interface DeleteCommentInput {
  comment_id: string
}

export interface TestCard {
  id: number | string,
  title: string,
  status: string,
  types: string,
  audiences: string[] | undefined,
  people: number,
  createdAt?: number | undefined,
  lastModified: number | undefined,
  // update type
  completedAt?: any,
}

export interface AudienceDemographic {
  key: string,
  value: string
}
export interface ProjectAudience {
  title: string,
  id?: string | null
  isLegacy?: boolean,
  additionalInfo?: string,
  organizationName?: string,
  demographics?: AudienceDemographic[]
}

export interface DuplicateCountMap {
  duplicates: number,
  [key: string]: boolean | number
}

export type Filter<T> = {
  [P in keyof T]?: T[P]
} & { searchTerm?: string }

export interface SearchItem {
  filter: Filter<any>,
  name: string
}

export interface DynamicAnswer {
  content: string
  show: boolean
  id: number
  children?: DynamicAnswer[]
  type: 'answer'
}

export interface DynamicAsset extends db.Asset {
  id: string
  idx: number
  isHighlighted?: boolean
  filters?: NestedTextFilter[]
  hasInsights?: boolean
  answers?: DynamicAnswer[]
  csv?: any
}

export interface DynamicQualAsset extends DynamicAsset {
  dynamicQual: true
  questionNumber: number
  answers: DynamicAnswer[]
  filename: string
  subtitle: string
}

export interface Mutations {
  assetIdx: number
  title: string
  charts?: Record<string, Partial<db.Chart>>
  textResponses?: Record<string, Partial<db.SubAsset>>
  analysis?: string
}

export interface FilteredDynamicAsset extends DynamicAsset, Partial<TextFilter> {
}

export interface Slice {
  url: string
  sliceKey: string
}

export type FilterMode = 'save' | 'delete'

export type LogicOperator = 'OR' | 'AND' | 'NOT'

export interface Term {
  word: string
  count: number
}

export interface TextFilter {
  keywords: string[]
  logicOperator: LogicOperator
  totalResponses: number
  name?: string
  originalTotalResponses?: number
  isRadioButton?: boolean | null
}

export interface NestedTextFilter extends TextFilter {
  answers?: DynamicAnswer[]
  notes: string
  subtitle: string
  title: string
  totalResponses: number
  type: 'filter'
}

export interface TestFilter {
  searchTerm: string | null,
  date: string | null,
  statuses: SelectOption,
  creators: SelectOption,
  audiences: SelectOption,
  testTypes: SelectOption,
  tags: SelectOption[]
}
export interface CSVFile {
  filename: string
  url?: string
  hosted?: boolean
}

export type SelectedTemplate = {
  template: graph.Template
  templateValues: Record<string, TemplateValue> | null
} | null
export const DEFAULT_TEMPLATE = { template: { id: -1 }, templateValues: null }
